import { css } from "@emotion/react";
import React from "react";
import { useTheme } from "../theme";

export interface ModalBackdropProps {
  children?: React.ReactNode;
}

export const ModalBackdrop = ({ children }: ModalBackdropProps) => {
  const theme = useTheme();
  return (
    <div
      css={css`
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: ${theme.zIndex.modal};
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin: 0px !important;
        &::before {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 100%;
          content: "";
          background-color: ${theme.palette.gray[900]};
          opacity: 0.7;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          width: 100%;
          max-height: 90vh;
        `}
      >
        {children}
      </div>
    </div>
  );
};
